import { useAuthStore } from '../../stores/useAuthStore';
import { AppleEmoji } from '../../components/AppleEmoji';
import { Link } from 'react-router-dom';

export default function ProfileView() {
  const user = useAuthStore((s) => s.user)!;

  return (
    <div className="page-view">
      <div className="page-view__header">
        <h1 className="page-view__title">
          <AppleEmoji emoji="👋" size={32} /> Привет!
        </h1>
        <p className="page-view__subtitle">Ваш профиль и статус верификации.</p>
      </div>

      {(!user.is_fully_verified ||
        !user.full_name ||
        user.full_name.trim().length < 2) && (
        <div className="info-banner info-banner--warn">
          <div className="info-banner__icon">
            <AppleEmoji emoji="⏳" size={28} />
          </div>
          <div>
            <div className="info-banner__title">Завершите верификацию</div>
            <div className="info-banner__text">
              Подтвердите телефон и укажите ФИО, чтобы совершать покупки USDT.
            </div>
          </div>
          <Link to="/account/verification" className="info-banner__btn">
            Начать
          </Link>
        </div>
      )}

      <div className="card-grid">
        <StatCard
          emoji="📧"
          label="Email"
          value={user.email || '—'}
          status={user.email_verified ? 'ok' : 'pending'}
          statusText={user.email_verified ? 'Подтверждён' : 'Не подтверждён'}
        />
        <StatCard
          emoji="📱"
          label="Телефон"
          value={user.phone_number || '—'}
          status={user.phone_verified ? 'ok' : 'pending'}
          statusText={user.phone_verified ? 'Подтверждён' : 'Не подтверждён'}
        />
        <StatCard
          emoji="🛡"
          label="KYC уровень"
          value={`Уровень ${user.kyc_level}`}
          status={user.kyc_level > 0 ? 'ok' : 'neutral'}
          statusText={
            user.sumsub_status === 'approved'
              ? 'Пройден'
              : user.sumsub_status === 'pending'
              ? 'На проверке'
              : user.sumsub_status === 'rejected'
              ? 'Отклонён'
              : 'Не начат'
          }
        />
        <StatCard
          emoji="🕐"
          label="Регистрация"
          value={new Date(user.created_at).toLocaleDateString('ru-RU', {
            day: '2-digit',
            month: 'long',
            year: 'numeric',
          })}
          status="neutral"
        />
      </div>
    </div>
  );
}

function StatCard({
  emoji,
  label,
  value,
  status,
  statusText,
}: {
  emoji: string;
  label: string;
  value: string;
  status: 'ok' | 'pending' | 'neutral';
  statusText?: string;
}) {
  return (
    <div className="stat-card">
      <div className="stat-card__emoji">
        <AppleEmoji emoji={emoji} size={32} />
      </div>
      <div className="stat-card__label">{label}</div>
      <div className="stat-card__value">{value}</div>
      {statusText && (
        <div className={`stat-card__status stat-card__status--${status}`}>
          {status === 'ok' && <AppleEmoji emoji="✓" size={12} />}
          {status === 'pending' && <AppleEmoji emoji="⏳" size={12} />}
          <span>{statusText}</span>
        </div>
      )}
    </div>
  );
}
